import React from "react";

import {HomeOutlined} from "@ant-design/icons";
import {Link} from "react-router-dom";

import {
	About,
	ContactUsLink,
	CurrentUserAvatar,
	GuideButton,
	GuideBotButton,
	WebSocketProvider,
	HomeLink,
	LogOut,
	OtherResources,
	UIConfigContext,
	openJiraWidgetOrReportError,
	initJiraWidgetObserver,
} from "@digatex/digatex-ui-lib";
import {Layout, Space, Typography} from "antd";

import api from "../../api";
import {CurrentUserContext} from "../../contexts/AuthContext.js";
import {properties, APP_INSTANCE, OTHER_RESOURCES_CONFIG} from "../../properties";
import {Logo} from "../../variants";

import "../helpers.css";
import "../../Dashboard.css";

class DHeader extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			triedToSubmit: false,
			submitInProgress: false,
			project: {},
		};

		this.formRef = React.createRef();
	}

	static contextType = CurrentUserContext;

	componentDidMount() {
		const projectId = document.location.pathname.split("/")[2];
		if (projectId) {
			api.get(`/projects/${projectId}/info`).then(json => this.setState({project: json.data}));
		}
		initJiraWidgetObserver();
	}

	showRequestForm = () => {
        openJiraWidgetOrReportError({
            moduleName: "Optimiser"
        });
	};

	render() {
		return (
			<div>
				<Layout.Header
					className={this.props.isLanding ? "landing-header" : undefined}
					style={{padding: 10, display: "flex", justifyContent: "space-between", alignItems: "center"}}>
					{!this.props.isLanding ? (
							<HomeLink image={Logo.image} />
						) : (
							<Link
								to="/landing"
								className={Logo.image ? "landing-home-with-logo" : undefined}
								style={{display: "flex", alignItems: "center", gap: 16}}>
								{Logo.image && <img id="logo" src={Logo.image} alt="Logo" />}
								<HomeOutlined
									id="home-button"
									style={{
										fontSize: 25,
										color: "white",
										verticalAlign: -4,
									}}
								/>
							</Link>
						)}
					{this.props.isLanding && (
						<Typography.Title
							level={3}
							style={{color: "white", paddingLeft: 32, paddingTop: 7.25, marginLeft: "auto"}}>
							{properties.landingHeaderName}
						</Typography.Title>
					)}
					{this.state.project.project_name && (
						<Typography.Title
							level={3}
							style={{color: "white", paddingLeft: 32, paddingTop: 7.25, marginLeft: "auto"}}>
							Project: {this.state.project.project_name}
						</Typography.Title>
					)}

					<div style={{marginLeft: "auto"}}>
						<Space size={"middle"}>
							<About />
							<UIConfigContext.Provider value={OTHER_RESOURCES_CONFIG}>
								<OtherResources />
							</UIConfigContext.Provider>
							{properties.guideBotApiLink && properties.guideBotWSLink ? (
								<div style={{paddingTop: 12}}>
									<WebSocketProvider moduleName="workbench">
										<GuideBotButton />
									</WebSocketProvider>
								</div>
							) : (
								<GuideButton module="workbench" />
							)}
							<ContactUsLink show={this.showRequestForm} />
							<LogOut />
							<CurrentUserAvatar />
						</Space>
					</div>
				</Layout.Header>
			</div>
		);
	}
}

export const DashboardHeader = DHeader;
